import React from 'react';
import { ChevronDownIcon, MapPinIcon } from 'lucide-react';
import { IMAGES, LINKS, PHONE_DISPLAY, PHONE_HREF } from '../data/site';
import { additionalServiceAreas, hours, locations, primaryServiceArea } from '../data/locations';
const serviceLinks = [{
  label: 'Auto Glass',
  href: LINKS.auto
}, {
  label: 'Windshield Chip Repair',
  href: LINKS.chip
}, {
  label: 'ADAS Calibration',
  href: LINKS.adas
}, {
  label: 'Residential Glass',
  href: LINKS.residential
}, {
  label: 'Glass Shower Doors',
  href: LINKS.shower
}, {
  label: 'Commercial Glass',
  href: LINKS.commercial
}];
const supportLinks = [{
  label: 'Glass Resources & Guides',
  href: LINKS.resources
}, {
  label: 'Emergency Auto Glass',
  href: LINKS.emergencyAuto
}, {
  label: 'Contact Kosin’s Glass',
  href: LINKS.contact
}, {
  label: 'Locations & hours',
  href: '#locations'
}];
export function Footer() {
  return <footer className="w-full bg-kosin-charcoal" data-id="element-59" data-mp="2ey0a6ay86mj8">
      <div className="mx-auto max-w-shell px-[18px] py-10 sm:px-6 lg:py-12" data-id="element-60" data-mp="2ezuubn1oaam9">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-[1fr_0.85fr_1fr_1.25fr]" data-id="element-61" data-mp="3lalf9cv8a1sw">
          <div data-id="element-62" data-mp="3gbijyk51v9y4">
            <div className="inline-block rounded bg-white px-3 py-2" data-id="element-63" data-mp="3gc0glhvmjq6k">
              <img src={IMAGES.logo} alt="Kosin’s Glass" width={227} height={95} className="h-[54px] w-auto" data-id="element-64" data-mp="3v7zuj95f0kjm" />
            </div>
            <p className="mt-4 text-[15px] leading-relaxed text-white/70" data-id="element-65" data-mp="81fojswysm2m">
              Family-owned glass company serving Southeast Michigan since 2000.
            </p>
            <a href={PHONE_HREF} className="focus-light mt-3 inline-block text-[17px] font-semibold text-white hover:text-kosin-bright transition-colors duration-150 ease-kosin" data-id="element-66" data-mp="ht39rc2xh6vn">
              {PHONE_DISPLAY}
            </a>
          </div>

          <nav aria-label="Services" data-id="element-67" data-mp="ms6hj4aalr7b">
            <h2 className="text-[13px] font-semibold uppercase text-white/60" data-id="element-68" data-mp="mt7q923u61lv">
              Services
            </h2>
            <ul className="mt-3 space-y-2 text-[15px]" data-id="element-69" data-mp="twxtpgfxzmch">
              {serviceLinks.map(link => <li key={link.label} data-id="element-70" data-mp="ys3egbxlyuyz">
                  <a href={link.href} className="focus-light text-white/80 hover:text-white transition-colors duration-150 ease-kosin" data-id="element-71" data-mp="13sr3is2a11qk">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <nav aria-label="Resources and contact" data-id="element-72" data-mp="1hjw53zp7g43j">
            <h2 className="text-[13px] font-semibold uppercase text-white/60" data-id="element-73" data-mp="1hmidu2nu0pnc">
              Resources &amp; contact
            </h2>
            <ul className="mt-3 space-y-2 text-[15px]" data-id="element-74" data-mp="1rjeoof17dnv2">
              {supportLinks.map(link => <li key={link.label} data-id="element-75" data-mp="3obwzv73o0ms8">
                  <a href={link.href} className="focus-light text-white/80 hover:text-white transition-colors duration-150 ease-kosin" data-id="element-76" data-mp="3oczplbp94j6k">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <section aria-labelledby="footer-service-area-heading" data-id="element-77" data-mp="25mkeer0ii4dr">
            <h2 id="footer-service-area-heading" className="text-[13px] font-semibold uppercase text-white/60" data-id="element-78" data-mp="21nl9v7ip09mu">
              Service Area
            </h2>
            <p className="mt-3 text-[15px] leading-relaxed text-white/80" data-id="element-79" data-mp="2tdpsb0mw6mlf">
              {primaryServiceArea}
            </p>
            <details className="group mt-2" data-id="element-80" data-mp="2pdfnvser048o">
              <summary className="focus-light flex min-h-11 cursor-pointer list-none items-center justify-between gap-2 text-[14px] font-semibold text-white hover:text-kosin-ondark [&::-webkit-details-marker]:hidden" data-id="element-81" data-mp="2paa2an5bvkhp">
                More Service Areas
                <ChevronDownIcon className="h-4 w-4 shrink-0 transition-transform group-open:rotate-180" aria-hidden="true" data-id="element-82" data-mp="18z5ycuyrs9g9" />
              </summary>
              <p className="mt-1 text-[14px] leading-relaxed text-white/75" data-id="element-83" data-mp="141e7m49v2tdn">
                {additionalServiceAreas.join(' · ')}
              </p>
            </details>
          </section>
        </div>

        <section id="locations" tabIndex={-1} aria-labelledby="footer-locations-heading" className="mt-8 border-t border-white/15 pt-8" data-id="element-84" data-mp="2woao2kt9vzod">
          <h2 id="footer-locations-heading" className="text-[20px] font-semibold text-white" data-id="element-85" data-mp="2ntcrn3qx24sa">
            Offices &amp; Business Hours
          </h2>
          <div className="mt-5 grid grid-cols-1 gap-8 lg:grid-cols-4" data-id="element-86" data-mp="3bhm43f28pg6r">
            <ul className="grid grid-cols-1 gap-8 text-[15px] text-white/80 sm:grid-cols-3 lg:col-span-3" data-id="element-87" data-mp="3fks96jdm91bn">
              {locations.map(office => <li key={office.city} className="min-w-0" data-id="element-88" data-mp="36kdnhiwqpk7m">
                  <h3 className="text-[18px] font-semibold text-white" data-id="element-89" data-mp="36issxtafe19r">
                    {office.city}
                  </h3>
                  <p className={`mt-1 text-[13px] font-semibold leading-5 ${office.isPrimary ? 'text-kosin-ondark' : 'text-white/60'}`} data-id="element-90" data-mp="1v5gwi3gzwkxm">
                    {office.isPrimary ? office.role : 'Satellite Office'}
                  </p>
                  <address className="mt-2 not-italic leading-relaxed" data-id="element-91" data-mp="1ino0s8pzh8fo">
                    {office.address.map(line => <span key={line} className="block" data-id="element-92" data-mp="1wm45ju4acov6">
                        {line}
                      </span>)}
                  </address>
                  <a href={office.phoneHref} className="focus-light inline-flex min-h-11 items-center font-semibold text-white hover:text-kosin-ondark transition-colors duration-150 ease-kosin" data-id="element-93" data-mp="13x6zqqh9gkjb">
                    {office.phoneDisplay}
                  </a>
                  {office.directionsUrl && <a href={office.directionsUrl} className="focus-light flex min-h-11 items-center gap-1.5 text-[14px] text-white/80 underline underline-offset-4 hover:text-white" data-id="element-94" data-mp="l7h4615obuqc">
                      <MapPinIcon className="h-4 w-4 shrink-0 text-kosin-ondark" aria-hidden="true" data-id="element-95" data-mp="g6b9hxsgdxe6" />
                      Get Directions To Howell
                    </a>}
                </li>)}
            </ul>
            <div data-id="element-96" data-mp="2q06sdb497mwp">
              <h3 className="text-[18px] font-semibold text-white" data-id="element-97" data-mp="2q1rnb1uhd7v3">Business Hours</h3>
              <dl className="mt-3 max-w-[380px] divide-y divide-white/10 border-y border-white/10 text-[14px]" data-id="element-98" data-mp="2uzt6rnvtj973">
                {hours.map(row => <div key={row.day} className="flex flex-wrap justify-between gap-x-3 gap-y-1 py-2.5" data-id="element-99" data-mp="1xe46lxwbz1dq">
                    <dt className="text-white/80" data-id="element-100" data-mp="22cp6fw7o7j1n">{row.day}</dt>
                    <dd className="m-0 whitespace-nowrap font-medium text-white" data-id="element-101" data-mp="278dzrht3k3pi">{row.time}</dd>
                  </div>)}
              </dl>
            </div>
          </div>
        </section>

        <p className="mt-8 border-t border-white/10 pt-5 text-[14px] text-white/60" data-id="element-102" data-mp="3iokuo32dl5e2">
          © {new Date().getFullYear()} Kosin’s Glass. All rights reserved.
        </p>
      </div>
    </footer>;
}